export default __webpack_public_path__ + "static/media/send.b9cde78f.svg";